import { GenericForm } from "../generic-form/GenericForm.types";
import { QdsRequestDTO } from "../../entities/IQdsRequest";

interface QdsRequestFormData {
  documentId: number;
  consentEmails: string[];
  holderSignerEmails: string[];
  counterPartyEmails: string[];
}

export const requestQdsForm: GenericForm<QdsRequestFormData> = {
  
  documentId: {
    type: "hidden",
    visibleIf: () => false,
    name: "documentId",
    label: "",
    defaultValue: -1,
    validators: [],
  },
  consentEmails: {
    type: "emailTags",
    name: "consentEmails",
    label: "DOCUMENTS.CONSENT_EMAILS",
    defaultValue: [],
    validators: [],
  },
  holderSignerEmails: {
    type: "emailTags",
    name: "holderSignerEmails",
    label: "DOCUMENTS.HOLDER_SIGNER_EMAILS",
    defaultValue: [],
    validators: [],
  },
  counterPartyEmails: {
    type: "emailTags",
    name: "counterPartyEmails",
    label: "DOCUMENTS.COUNTERPARTY_EMAILS",
    defaultValue: [],
    validators: [],
  },
};

export interface RequestQdsModalProps {
  onDismiss: () => void;
  onSubmit: (data: QdsRequestDTO) => void;
  creating: boolean;
  isVisible: boolean;
  requestQdsForm: GenericForm<QdsRequestFormData>;
}
